import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode"; 

const NonLoginGuard = () => {
  const [auth, setAuth] = useState(false); 
  const [loading, setLoading] = useState(true); 

  console.log("hit 2");

  useEffect(() => {
    const token = localStorage.getItem("token");
    console.log("token", token);

    if (token) {
      try {
        const decodedToken = jwt_decode(token); 
        console.log("Decoded Token:", decodedToken);

        const currentTime = Date.now() / 1000;

        if (decodedToken.exp >= currentTime) {
          setAuth(true);
          toast.info("Welcome back!", {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.error("Please login to view this page", {
            position: toast.POSITION.TOP_RIGHT,
          });
          localStorage.removeItem("token");
          setAuth(false);
        }
      } catch (error) {
        console.error("Invalid token:", error);
        localStorage.removeItem("token");
        setAuth(false);
      }
    } else {
      setAuth(false); 
    }

    setLoading(false);
  }, []);

  if (loading) {
    return <div>Loading...</div>; 
  }

  return !auth ? <Outlet /> : <Navigate to="/dashboard" />;
};

export default NonLoginGuard;
